module.exports = "/_next/static/images/Frame-b8da18d4b80649380e00b13cac58c5e2.webp";